/** Shared role constants — single source of truth across the whole app */

export const ADMIN_ROLES  = ['owner', 'admin'];
export const MANAGE_ROLES = ['owner', 'admin', 'manager'];
export const STAFF_ROLES  = ['employee', 'manager', 'admin', 'owner'];
